<!--
    HOC (Higher-Order Component) that dispatches to the correct tile layout
    based on the `tileLayout` prop. Add new layout variants here.
-->
<script lang="ts">
    import type { Variation } from '@shared/types/types.ts';
    import type { ImageAspectRatio } from '@tile/components/product-image/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import type { TileLayout } from '@tilelist/domain/composition/BracketLayout.ts';
    import DefaultLayout from '@tilelist/layouts/default-layout/DefaultLayout.svelte';
    import { createDefaultLayout } from '@tilelist/layouts/default-layout/DefaultLayout.ts';
    import FashionLayout from '@tilelist/layouts/fashion-layout/FashionLayout.svelte';
    import { createFashionLayout } from '@tilelist/layouts/fashion-layout/FashionLayout.ts';
    import type { TileLayoutProps } from '@tilelist/layouts/shared/TileLayoutProps.ts';

    type Props = TileLayoutProps & {
        tileLayout: TileLayout;
        variation: Variation;
        aspectRatio: ImageAspectRatio;
        showTopInfos: boolean;
        showInstallments: boolean;
        showMultipleSizes: boolean;
    };

    let { tileLayout, variation, aspectRatio, showTopInfos, showInstallments, showMultipleSizes, ...coreProps }: Props =
        $props();

    const onex = $derived(injectWiring().onex);
    const cleanTileActive = $derived(onex.isExperimentGroup('CLEAN_TILE_V3', 'E3918B'));
</script>

{#if tileLayout === 'fashion' && cleanTileActive}
    <FashionLayout {...coreProps} layout={createFashionLayout(variation)} {aspectRatio} />
{:else if tileLayout === 'fashion'}
    <FashionLayout {...coreProps} layout={createFashionLayout(variation)} {aspectRatio} />
{:else if cleanTileActive}
    <DefaultLayout
        {...coreProps}
        layout={createDefaultLayout(variation, showTopInfos, showMultipleSizes)}
        {aspectRatio}
        {showInstallments}
    />
{:else}
    <DefaultLayout
        {...coreProps}
        layout={createDefaultLayout(variation, showTopInfos, showMultipleSizes)}
        {aspectRatio}
        {showInstallments}
    />
{/if}
